var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFileExcel = function SvgDownloadFileExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD1B9",
    fillRule: "evenodd",
    d: "m26.286 10.288-8.002-8.002H8.114a2.4 2.4 0 0 0-2.4 2.4v22.629a2.4 2.4 0 0 0 2.4 2.4h15.772a2.4 2.4 0 0 0 2.4-2.4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9A476",
    d: "M18.284 10.286v-8l8 8zM16.858 14.024a.69.69 0 0 1 .868.666v10.62a.69.69 0 0 1-.868.666l-6.347-1.7A.69.69 0 0 1 10 23.61v-7.22a.69.69 0 0 1 .511-.666zm3.385 1.69c.497 0 .9.449.9 1v6.572c0 .552-.403 1-.9 1h-.772c-.453 0-.827-.373-.89-.858h1.705a.857.857 0 0 0-.857-.857h-.858v-.857h1.715a.857.857 0 0 0-.857-.857h-.858V20h1.715a.857.857 0 0 0-.857-.858h-.858v-.857h1.715a.857.857 0 0 0-.857-.857h-.858v-.713c0-.552.403-1 .9-1zm-6.906 4.477v.008l-1.194 1.943h.848l.82-1.352h.025l.825 1.352h.895l-1.215-1.927v-.01l1.23-1.92h-.876l-.793 1.39h-.029l-.798-1.39h-.925z"
  })));
};
export default SvgDownloadFileExcel;